"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.InvestorsMatrixEntity = exports.getMatrix = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../types");
var fields_1 = require("../../fields");
var document_factory_1 = require("./document-factory");
var getMatrix = function (prismicDoc, logger) {
    var matrix = prismicDoc.data.investors_matrix_slices;
    var lines = matrix === null || matrix === void 0 ? void 0 : matrix.map(function (item) { return toMatrixLine(item, logger); }).filter(Boolean);
    if (!(lines === null || lines === void 0 ? void 0 : lines.length)) {
        return null;
    }
    return lines;
};
exports.getMatrix = getMatrix;
var toMatrixLine = function (sliceData, logger) {
    var data = sliceData.primary;
    var transmissionDate = logger.required(fields_1.toTimestamp(data.transmission_date));
    var termDate = logger.required(fields_1.toTimestamp(data.term_date));
    var termText = logger.required(fields_1.toText(data.term_text));
    var amount = logger.required(fields_1.toText(data.amount));
    var coupon = logger.required(fields_1.toText(data.coupon));
    var place = logger.required(fields_1.toText(data.place));
    var isin = logger.required(fields_1.toText(data.isin));
    var documents = sliceData.items
        .map(function (item) { return fields_1.toMediaLink(item.doc, logger); })
        .filter(Boolean);
    // Test des champs obligatoires
    if (!(transmissionDate &&
        (termDate || termText) &&
        amount &&
        coupon &&
        place &&
        isin)) {
        return undefined;
    }
    return utils_1.compact({
        transmissionDate: transmissionDate,
        termDate: termDate,
        termText: termText,
        amount: amount,
        coupon: coupon,
        place: place,
        isin: isin,
        documents: documents
    });
};
exports.InvestorsMatrixEntity = document_factory_1.documentFactory(types_1.DocumentType.INVESTORS_MATRIX, function (prismicDoc, normalizedDoc, logger) {
    return utils_1.compact(__assign(__assign({}, normalizedDoc), { title: logger.required(fields_1.toText(prismicDoc.data.investors_matrix_title)), description: fields_1.toText(prismicDoc.data.investors_matrix_description), matrix: exports.getMatrix(prismicDoc, logger) }));
});
//# sourceMappingURL=investors-matrix.js.map